import {
  AttributeDurationOption,
  BankAccountDisplayOption,
  BankAccountOption,
  CardDesignFormValues,
  DonateTypeOption,
  ProjectType,
  SearchValues,
} from "../types";

// Default search values
export const searchValues: SearchValues = {
  title: "",
  toDate: "",
  fromDate: "",
  toAmount: "",
  isActive: "",
  isArchived: "",
  fromAmount: "",
  isCompleted: "",
  showInHomePage: "",
  classificationIds: "",
};

// Options for donation types
export const donateTypeOptions: DonateTypeOption[] = [
  { value: ProjectType.Grades, name: "فئات" },
  { value: ProjectType.Open, name: "تبرع مفتوح" },
  { value: ProjectType.Deduction, name: "استقطاع" },
  { value: ProjectType.Meal, name: "إفطارات" },
];

// Options for attribute durations
export const attributeDurationsOptions: AttributeDurationOption[] = [
  { value: "0", name: "يومي" },
  { value: "2", name: "شهري" },
  { value: "5", name: "سنوي" },
  { value: "1", name: "اسبوعي" },
  { value: "3", name: "كل 3 شهور" },
  { value: "4", name: "كل 6 شهور" },
];

// Options for bank account display
export const bankAccountOptions: BankAccountOption[] = [
  { value: BankAccountDisplayOption.Hidden, name: "إخفاء الحسابات البنكية" },
  { value: BankAccountDisplayOption.Above, name: "إظهار الحسابات البنكية فوق وصف المشروع" },
  { value: BankAccountDisplayOption.Below, name: "إظهار الحسابات البنكية تحت الوصف المشروع" },
];

// Mapping of Excel header cells to field names
export const excelHeaderCellsName: Record<string, string> = {
  "المعرف": "id",
  "عنوان": "title",
  "نشط": "isActive",
  "مؤرشف": "isArchived",
  "تصنيفات": "classifications",
  "صورة المشروع": "imageFullUrl",
  "عدد التبرعات": "donationCount",
  "المبلغ الإجمالي": "totalAmount",
  "فئة المشروع": "projectCategory",
  "المبلغ المطلوب": "requiredAmount",
  "نسبة التحقق": "progressPercentage",
};


// Initial values for gift card design
export const cardDesignInitialValuesForAll: CardDesignFormValues[] = [
  {
    x: 30,
    y: 30,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 0,
    shadowBlur: 4,
    content: "المهدي ",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
  {
    x: 30,
    y: 30,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 1,
    shadowBlur: 4,
    content: "المهدي اليه",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
  {
    x: 30,
    y: 30,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 2,
    shadowBlur: 4,
    content: "المشروع",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
  {
    x: 40,
    y: 40,
    xWithTextWidth: 30,
    shadowX: 2,
    shadowY: 2,
    show: false,
    fontSize: 16,
    alignment: 1,
    disclaimer: 3,
    shadowBlur: 4,
    content: "الاسهم",
    color: "#000000",
    hasShadow: false,
    borderThickness: 0,
    borderColor: "#000000",
    shadowColor: "#000000",
  },
];
